var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegisteredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57874 6.82739C7.35681 6.82739 8.82422 5.4251 8.82422 3.66369C8.82422 1.90229 7.35681 0.5 5.57874 0.5C3.80067 0.5 2.33325 1.90229 2.33325 3.66369C2.33325 5.4251 3.80067 6.82739 5.57874 6.82739Z",
    stroke: "#14142B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57581 14.2645C6.88516 14.2645 8.09323 14.0594 8.99229 13.7105C9.44021 13.5367 9.83685 13.3174 10.1301 13.0483C10.4236 12.7789 10.6516 12.4215 10.6516 11.9887C10.6516 11.5559 10.4236 11.1984 10.1301 10.929C9.83685 10.66 9.44021 10.4407 8.99229 10.2669C8.09323 9.91797 6.88516 9.71289 5.57581 9.71289C4.26646 9.71289 3.05838 9.91797 2.15933 10.2669C1.7114 10.4407 1.31477 10.66 1.02155 10.929C0.727966 11.1984 0.5 11.5559 0.5 11.9887C0.5 12.4215 0.727966 12.7789 1.02155 13.0483C1.31477 13.3174 1.7114 13.5367 2.15933 13.7105C3.05838 14.0594 4.26646 14.2645 5.57581 14.2645Z",
    stroke: "#14142B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0006 3.37109L17.1187 9.30015L14.4451 6.60512",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisteredIcon);
export default __webpack_public_path__ + "static/media/RegisteredIcon.d2cb0a8263e4d6c4513f56a0b1cfe560.svg";
export { ForwardRef as ReactComponent };